import "./accountCancelViewWizardStep1.scss";

import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

import AccountCancelViewWizardMotiveSelect from "../accountCancelViewWizardMotiveSelect/accountCancelViewWizardMotiveSelect";

const baseClassName = "account-cancel-view-wizard-step-one";

function AccountCancelViewWizardStep1(props) {
    const { immAccountCancel, accountCancelMotiveSelectChanged, accountCancelMotiveInputChanged } = props;
    
    return <article className={baseClassName}>
        <h2 className={`${baseClassName}__title`}>
            <FormattedText value="cancellation_account-account_cancellation_request_step1_title" />
        </h2>
        <section>
            <p className={`${baseClassName}__description`}>
                <FormattedText value="cancellation_account-account_cancellation_request_step1_sub_title" />
            </p>
            <ul className={`${baseClassName}__advantages-list`}>
                <li className={`${baseClassName}__advantages-item`}>
                    <div className={`${baseClassName}__advantages-icon-container`}>
                        <i className={`${baseClassName}__advantages-free-icon`}></i>
                    </div>
                    <div className={`${baseClassName}__advantages-texts`}>
                        <p className={`${baseClassName}__advantages-first-text`}>
                            <FormattedText value="cancellation_account-account_cancellation_request_step1_advantage_1_title" />
                        </p>
                        <p className={`${baseClassName}__advantages-second-text`}>
                            <FormattedText value="cancellation_account-account_cancellation_request_step1_advantage_1_description" />
                        </p>
                    </div>
                </li>
                <li className={`${baseClassName}__advantages-item`}>
                <div className={`${baseClassName}__advantages-icon-container`}>
                    <i className={`${baseClassName}__advantages-transfer-icon`}></i>
                </div>
                    <div className={`${baseClassName}__advantages-texts`}>
                        <p className={`${baseClassName}__advantages-first-text`}>
                            <FormattedText value="cancellation_account-account_cancellation_request_step1_advantage_2_title" />
                        </p>
                        <p className={`${baseClassName}__advantages-second-text`}>
                            <FormattedText value="cancellation_account-account_cancellation_request_step1_advantage_2_description" />
                        </p>
                    </div>
                </li>
            </ul>
        </section>
        <section>
            <div className={`${baseClassName}__motives-preface`}>
                <h3 className={`${baseClassName}__motives-title`}>
                    <FormattedText value="cancellation_account-account_cancellation_request_step1_cancel_confirmation_text_title" />
                </h3>
                <p className={`${baseClassName}__motives-description`}>
                    <FormattedText value="cancellation_account-account_cancellation_request_step1_cancel_confirmation_text_description" />
                </p>
            </div>
            <AccountCancelViewWizardMotiveSelect 
                immAccountCancel={immAccountCancel} 
                onSelectChange={accountCancelMotiveSelectChanged} 
                onInputChange={accountCancelMotiveInputChanged}
            />
        </section>
    </article>
}

AccountCancelViewWizardStep1.propTypes = {
    immAccountCancel: PropTypes.object.isRequired,
    accountCancelMotiveSelectChanged: PropTypes.func.isRequired,
    accountCancelMotiveInputChanged: PropTypes.func.isRequired,
};



export default AccountCancelViewWizardStep1;